
import Api from '@/utils/api';
import _ from 'lodash';
import NotData from '../NoData/NoData.vue';
import Toast from 'vux/src/components/toast/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import querystring from 'vux/src/tools/querystring/index.js'

import {
cartUpdate,
removeCart,
getCartInfo
} from '../../api'

export default {
data() {
return {
cartList: []
}
},
created() {
this.getCartList()
},
components: {
Toast,
XImg,
NotData
},
computed: {
isSelectActive(item) {

},

allMoney() {
let total = 0
_.forEach(this.cartList, (cart) => {
if(cart.selected){
total += cart.product.price * cart.quantity
}
})
return total
}
},
methods: {
add(item){
item.quantity ++
this.updatedCartQuantity(item)
},
rem(item){
const that = this
if(item.quantity === 1){
this.$vux.confirm.show({
title: '删除',
content: '确认删除此商品',
onConfirm () {
Api.deleteProductCart(item.product._id)
.then(res => {
that.$vux.toast.show({
text: '删除成功',
})
that.getCartList()
Api.getCartCount()
})
}
})
}else{
item.quantity --
this.updatedCartQuantity(item)

}
},
updatedCartQuantity: _.debounce(function (item) {
Api.updatedCartQuantity(item.product._id, {
quantity: item.quantity
})
.then(res => {
})
}, 500),
getCartList() {
Api.getCartList()
.then(res => {
this.cartList = res.data
_.forEach(this.cartList, (cart) => {
this.$set(cart, 'selected', true)
})
})
},
selectItem(item) {
this.$set(item, 'selected', !item.selected)
},
selectAll() {
const switchSelectAll = !this.isSelectedAll()
_.forEach(this.cartList, (cart) => {
this.$set(cart, 'selected', switchSelectAll)
})
},
selectedItems() {
return _.filter(this.cartList, {selected: true})
},
isSelectedAll() {
return this.cartList.length == this.selectedItems().length
},
toDetail(id) {
this.$router.push({
name: 'detail',
params: {
id: id
}
})
},
deleteCart() {
const that = this
this.$vux.confirm.show({
title: '清空',
content: '确认清空购物车',
onConfirm () {
Api.deleteCart()
.then(res => {
that.$vux.toast.show({
text: '清空成功'
})
that.getCartList()
Api.getCartCount()
})
}
})
},
toPay(){
let selectedCart = _.filter(this.cartList, {selected: true})
this.$router.push({
name: 'createOrder',
query: {
selectedCart: JSON.stringify(selectedCart)
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/ShoppCart/ShoppCart.vue